export const PRICING = {
  page: "admin-pricing-page",
  navLink: "admin-pricing-nav",
  firstOrderInput: "pricing-first-order",
  reorderInput: "pricing-reorder",
  shippingInput: "pricing-shipping",
  saveBtn: "pricing-save-btn",
};

export const ADMIN_FILTERS = {
  searchInput: "admin-search-input",
  statusSelect: "admin-status-filter",
  clearBtn: "admin-clear-filters",
};

export const ORDER_BREAKDOWN = {
  container: "order-breakdown",
  orderType: "order-breakdown-type",
  unitPrice: "order-breakdown-unit",
  subtotal: "order-breakdown-subtotal",
  shipping: "order-breakdown-shipping",
  total: "order-breakdown-total",
};
